<template>
  <div class>
    <v-toolbar dark :color="this.$gf.headerColor()">
      <v-toolbar-title>
        <v-icon class="icon">fa-plus</v-icon>Release Updates
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab small class="close" @click="closePanel">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container>
      <v-layout>
        <v-flex xs12>
          <v-form>
            <v-text-field :error-messages="messages.title" v-model="updates.title" label="Title" type="text"
              filled></v-text-field>
            <v-menu :close-on-content-click="false" v-model="menuCompleted" max-width="290" >
              <template v-slot:activator="{ on }">
                <v-text-field :value="computedReleaseDate" :error-messages="messages.release_date" clearable
                  label="Release Date" readonly v-on="on" filled @click:clear="clearDate"></v-text-field>
              </template>
              <v-date-picker v-model="updates.release_date" @change="menuCompleted = false"
                 @input="menuCompleted = false" color="primary"></v-date-picker>
            </v-menu>
            <v-input
                      hide-details="auto"
                      required
                      class="notification-textarea"
                      v-model="updates.features"
                      :error-messages="messages.features"
                    >
            <ckeditor :editor="editor" class="ckeditor" v-model="updates.features" tag-name="textarea"
              :config="editorConfig">
            </ckeditor>
            </v-input>
            <drop-zone
              :type="type"
              :accepted="accepted"
              :image.sync="releaseImg"
              :dropzone-id="'releaseImg'"
              class="mt-5"
              text="Click here to upload Release Image"
            ></drop-zone>
            <p class="block text-left mt-4 caption">
              Max upload filesize: 10MB <br />
              Accepted file formats: png, jpg, jpeg
            </p>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
    <v-footer height="68">
      <v-flex text-right>
        <template v-if="loading">
            <v-btn color="primary" loading></v-btn>
        </template>
        <template v-else>
          <v-btn color="grey300" class="mr-4 cancel-button" @click="closePanel">Cancel</v-btn>
          <v-btn color="primary" @click="saveReleaseUpdates">Save</v-btn>
        </template>
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import { EventBus } from '@/event-bus.js';
import superAdminAPI from '@/api/superadmin.js';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import moment from "moment";
import DropZone from '@/components/global/Dropzone';

export default {
  name: 'NewRelease',
  components: {
    DropZone,
  },
  props: {
    id: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      type: 'release-update',
      accepted: 'image/jpg,image/jpeg,image/png',
      editorConfig: {
        toolbar: {
          items: [
            'undo', 'redo',
            '|', 'heading',
            '|', 'bold', 'italic',
            '|', 'bulletedList', 'numberedList',
            '|', 'link'
          ]
        },
      },
      editor: ClassicEditor,
      menuCompleted: false,
      updates: {},
      messages: {},
      loading: false,
      successMessage: 'Release updates are added successfully.',
      errorMessage:
        'Oops, something went wrong! Please check information is correct.',
    };
  },
  computed: {
    computedReleaseDate() {
      return this.updates.release_date
        ? moment(this.updates.release_date).format("DD-MM-YYYY")
        : "";
    },
    s3Uploading() {
      return this.$store.getters.s3Uploading;
    },
    releaseImg() {
      return this.updates.hasOwnProperty('releaseImage')
        ? this.updates.releaseImage.data
        : null;
    },
  },
  mounted() {
    this.$store.dispatch('setS3Uploading', false);
    if (this.id){
      this.getReleaseDetails(this.id)
    }
  },
  methods: {
    closePanel() {
      this.$emit('closePanel', {});
    },
    getReleaseDetails(releaseId) {
      this.loading = true;
      superAdminAPI
        .getReleaseUpdates(releaseId)
        .then((response) => {
          this.updates = response.data.data;
          this.$store.dispatch('setDropzoneLoaded', { id: 'releaseImg', value: true });
          this.loading = false;
        })
        .catch(() => {
          this.$snotify.error(this.errorMessage);
          setTimeout(() => {
            this.$gf.removeBackdrop();
          }, 300);
          this.loading = false;
        });
    },
    saveReleaseUpdates() {
      this.loading = true;
      superAdminAPI
        .saveReleaseUpdates(
          this.updates,
          this.$store.getters.s3Url,
          this.$store.getters.fileDetails
        )
        .then((response) => {
          this.closePanel();
          EventBus.$emit('RELEASE_UPDATED');
          this.$snotify.success(response.data.message);
          setTimeout(() => {
            this.$gf.removeBackdrop();
          }, 300);
          this.loading = false;
        })
        .catch((err) => {
          this.valid = false;
          this.messages = this.$gf.errorResponse(err);
          this.$snotify.error(this.errorMessage);
          setTimeout(() => {
            this.$gf.removeBackdrop();
          }, 300);
          this.loading = false;
        });
    },
    clearDate() {
     this.updates.release_date = null; // 👈 This clears the selected date
    }
  },
};
</script>
